import permissionsService from './permissionsService'

export default {
  bind(el, binding) {
    const { permission, module, section, fallbackRoles = [], allRoles = false } = binding.value || {}

    const checkAccess = () => {
      const hasAccess = permissionsService.hasPermissionOrFallback({
        permission,
        module,
        fallbackRoles,
        allRoles,
        section
      })
      el.style.setProperty('display', hasAccess ? '' : 'none', 'important')
    }

    checkAccess()
    window.addEventListener('permissions-updated', checkAccess)
    el.__canCheckAccess__ = checkAccess
  },
  unbind(el) {
    window.removeEventListener('permissions-updated', el.__canCheckAccess__)
    delete el.__canCheckAccess__
  }
}
